<div class="container">
    <div class="col-12 p-3" style="height: 100vh;">



        <div class="image-div mb-5 align-items-center justify-content-center d-flex">

            <img class="img-fluid" src="assets/DM logocolour.jpg" alt="Dorwin" />
            <p> <small class="align-items-center">v11.1.6</small>
            </p>
            <!-- <div>
                <button mat-raised-button color="primary" class="m-auto"><mat-icon>exit_to_app</mat-icon>
                    Logout</button>
            </div> -->
        </div>

        <div style="text-align: center;display: flex;justify-content: center;">
            <div>
                <input type="tel" autofocus placeholder="Phone Number" style="text-align: center;"
                    class="example-full-width" [(ngModel)]="phone" mask="(000) 000-0000" (keydown)="onKeydown($event)">
                <br>
                <span style="font-size: 12px;">Press [Enter] To Send</span>
            </div>
            <div>
                <span> &nbsp; Rapid Entry</span>
                <mat-slide-toggle class="ms-3" [(ngModel)]="callToggle"
                    (toggleChange)="toggleChange()">{{methodDisplayView}} </mat-slide-toggle>
            </div>
        </div>

        <!-- <div class="align-items-center justify-content-center d-flex mt-3">
            <button mat-raised-button color="accent" >Submit</button>

        </div> -->
        <!-- <div class="powered-by">
            Powered by  <img src="assets/aux_logo.png" alt="Amherstburg" class="pb-2" />
          </div> -->
        <div class="mt-4 align-items-center justify-content-center" style="max-width: 50vw;margin: auto;">
            <table id="customers">
                <tr>
                    <th>Time</th>
                    <th>Phone</th>
                    <th>Method</th>
                    <!-- <th></th> -->
                </tr>
                <tbody>
                    <tr *ngFor="let d of tableData;let i =index"
                        [ngClass]="{'red-bg': d.MethodDisplay == 'DO NOT CALL'}" [ngStyle]="{'background-color': d.bgcolor }">
                        <td>{{d.Call | date: 'h:mm a'}}</td>
                        <td>{{d.PhoneNumber | mask: '(000) 000-0000'}}</td>
                        <td>{{d.MethodDisplay}} </td>
                    </tr>

                </tbody>


            </table>
        </div>
    </div>
</div>